<div class="kt-portlet kt-portlet--responsive-mobile">
  <div class="kt-portlet__head">
    <div class="kt-portlet__head-label">
      <h2 class="kt-portlet__head-title text-capitalize"
        >Request For Quotes | <b> Inventory </b> Retail Prices</h2
      >
    </div>
    <div class="kt-portlet__head-toolbar"></div>
  </div>

  <div class="kt-portlet__body">
    <h3 class="loading-pipelines text-center" *ngIf="loadingRfqs"
      ><i class="fas fa-spinner fa-spin"></i> Loading skus...</h3
    >

    <div class="filters form-inline" *ngIf="!loadingRfqs">
      <label for="" class="mr-2">FILTER SKU: </label>
      <div class="form-group form-inline mr-2">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filter.keyword"
          (keydown.enter)="getRecords(false, 1)"
        />
      </div>
    </div>

    <div class="overflow-auto" *ngIf="!loadingRfqs">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Product Name</th>
            <th *ngFor="let ch of channels" class="text-right">{{ ch.label }}</th>
          </tr>
        </thead>
        <tbody>
          <!-- <tr
                        *ngFor="let rfq of rfqs  |  filter: {internal_sku: filter.keyword}  | paginate: { itemsPerPage: pageSize, currentPage: page }; let i=index"> -->
          <tr *ngFor="let rfq of rfqRecord.data">
            <td>
              {{ rfq.internal_sku }}
            </td>
            <td>
              {{ rfq.product_name }}
            </td>
            <td *ngFor="let ch of rfq.channels" class="text-right">
              <span *ngIf="ch.price > 0"> {{ ch.price | currency: '' }} </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between p-2">
      <mat-paginator
        [length]="rfqRecord.total"
        [pageSize]="rfqRecord.per_page"
        [pageSizeOptions]="pageSizeOptions"
        (page)="getRecords($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
